/**
 * PolicyListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  TabContent,
  InputFormTable,
} from 'components';
import { Input, Button, Select } from 'antd';

const PolicyListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form1 = [
    {
      label: '정기배송 정책',
      form: [
        {
          input: (
            <Input.TextArea
              placeholder="내용을 입력해주세요"
              style={{ height: 98 }}
            />
          ),
          fullscreen: true,
          count: true,
          maxLength: 500,
        },
      ],
    },
    {
      label: '배송정지 기한 설정',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={3}
                options={[
                  { label: '배송 3일 전', value: 3 },
                  { label: '배송 5일 전', value: 5 },
                  { label: '배송 7일 전', value: 7 },
                  { label: '배송 10일 전', value: 10 },
                ]}
              />
            </>
          ),
        },
        {
          input: (
            <>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                까지 취소/미루기를 하지 않은 상품은 배송을 정지할 수 없습니다.
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '정보변경 기한 설정',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={3}
                options={[
                  { label: '배송 3일 전', value: 3 },
                  { label: '배송 5일 전', value: 5 },
                  { label: '배송 7일 전', value: 7 },
                  { label: '배송 10일 전', value: 10 },
                ]}
              />
            </>
          ),
        },
        {
          input: (
            <>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                까지 변경되지 않은 정보(결제, 주소, 결제일 등)는 당월 배송에
                반영되지 않습니다.
              </p>
            </>
          ),
        },
      ],
    },
  ];
  const form2 = [
    {
      label: '렌탈 정책',
      form: [
        {
          input: (
            <Input.TextArea
              placeholder="내용을 입력해주세요"
              style={{ height: 98 }}
            />
          ),
          fullscreen: true,
          count: true,
          maxLength: 500,
        },
      ],
    },
    {
      label: '점검 기한 설정',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={1}
                options={[
                  { label: '점검 1일 전', value: 1 },
                  { label: '점검 3일 전', value: 3 },
                  { label: '점검 5일 전', value: 5 },
                  { label: '점검 7일 전', value: 7 },
                  { label: '점검 10일 전', value: 10 },
                ]}
              />
            </>
          ),
        },
        {
          input: (
            <>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                까지 미루기를 하지 않은 점검은 정지할 수 없습니다.
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '약정일 갱신 설정',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={3}
                options={[
                  { label: '만료 3일 전', value: 3 },
                  { label: '만료 5일 전', value: 5 },
                  { label: '만료 7일 전', value: 7 },
                  { label: '만료 10일 전', value: 10 },
                ]}
              />
            </>
          ),
        },
        {
          input: (
            <>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                까지 변경되지 않은 약정은 자동 갱신됩니다.
              </p>
            </>
          ),
        },
      ],
    },
  ];
  const form3 = [
    {
      label: '개인정보 처리방침',
      form: [
        {
          input: (
            <Input.TextArea
              placeholder="내용을 입력해주세요"
              style={{ height: 98 }}
            />
          ),
          fullscreen: true,
          count: true,
          maxLength: 1000,
        },
      ],
    },
    {
      label: '서비스 이용약관',
      form: [
        {
          input: (
            <Input.TextArea
              placeholder="내용을 입력해주세요"
              style={{ height: 98 }}
            />
          ),
          fullscreen: true,
          count: true,
          maxLength: 1000,
        },
      ],
    },
    {
      label: '환불규정',
      form: [
        {
          input: (
            <Input.TextArea
              placeholder="내용을 입력해주세요"
              style={{ height: 98 }}
            />
          ),
          fullscreen: true,
          count: true,
          maxLength: 1000,
        },
      ],
    },
  ];

  const tabItems = [
    {
      label: `정기배송 정책 관리`,
      key: `tab_1`,
      children: (
        <div>
          <InputFormTable form={form1} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 26,
            }}
          >
            <Button
              size="large"
              style={{
                ...styles.button,
                background: 'var(--primary-color)',
                color: '#FFFFFF',
              }}
            >
              저장
            </Button>
            <Button size="large" style={{ ...styles.button }}>
              초기화
            </Button>
          </div>
        </div>
      ),
    },
    {
      label: `렌탈 정책 관리`,
      key: `tab_2`,
      children: (
        <div>
          <InputFormTable form={form2} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 26,
            }}
          >
            <Button
              size="large"
              style={{
                ...styles.button,
                background: 'var(--primary-color)',
                color: '#FFFFFF',
              }}
            >
              저장
            </Button>
            <Button size="large" style={{ ...styles.button }}>
              초기화
            </Button>
          </div>
        </div>
      ),
    },
    {
      label: `이용약관 관리`,
      key: `tab_3`,
      children: (
        <div>
          <InputFormTable form={form3} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 26,
            }}
          >
            <Button
              size="large"
              style={{
                ...styles.button,
                background: 'var(--primary-color)',
                color: '#FFFFFF',
              }}
            >
              저장
            </Button>
            <Button size="large" style={{ ...styles.button }}>
              초기화
            </Button>
          </div>
        </div>
      ),
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>정책 관리</Title>

          {/* 정책목록 */}
          <Content maxWidth={'100%'} padding={20} borderRadius={4}>
            <TabContent items={tabItems} />
          </Content>
          {/* 정책목록 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default PolicyListPresenter;
